/**
 * Card primitive - Direction A "Tu phap restraint"
 *
 * 3 variant: default (paper-elev + border) | elevated (shadow-md) | flush (paper-sunk no border)
 * Padding: token 1-7 (4px..48px)
 *
 * Polymorphic via `as` prop (default 'div'). Supports section/article/aside/li.
 * Token reuse only.
 *
 * Phase 1 Track 2 (2026-05-22).
 */

import * as React from 'react';

export type CardVariant = 'default' | 'elevated' | 'flush';
export type CardPadding = 1 | 2 | 3 | 4 | 5 | 6 | 7;
export type CardAs = 'div' | 'section' | 'article' | 'aside' | 'li';

export interface CardProps extends React.HTMLAttributes<HTMLElement> {
  variant?: CardVariant;
  padding?: CardPadding;
  as?: CardAs;
  children: React.ReactNode;
}

export const Card = React.forwardRef<HTMLElement, CardProps>(function Card(
  {
    variant = 'default',
    padding = 4,
    as = 'div',
    className,
    children,
    ...rest
  },
  ref
) {
  const cls = [
    'ask-card',
    variant !== 'default' ? `ask-card--${variant}` : '',
    `ask-card--pad-${padding}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return React.createElement(
    as,
    {
      ref,
      className: cls,
      ...rest,
    },
    children
  );
});
